import React, { useState, useLayoutEffect } from "react";
import { Switch, Route } from "react-router-dom";
import { redirectToLoginPage } from "../utils/routes";
import { useSelector, useDispatch } from "react-redux";
import Log from "../utils/Log";
import ProfileSideNav from "./helpers/ProfileSideNav.jsx";
import UserProfile from "./account/UserProfile.jsx";
import UserSubscription from "./account/UserSubscription.jsx";
import UserSupport from "./account/UserSupport.jsx";
import UserAdManagement from "./admanager/UserAdManagement.jsx";
import ProfilePaymentHistoryPage from "./ProfilePaymentHistoryPage.jsx";
import ManagePaymentPage from "./ManagePaymentPage.jsx";
import ProfileProductPage from "./ProfileProductPage.jsx";
import styles from "../styles/UserAccount.module.scss";
import BreadCrumbWrapper from "./helpers/BreadcrumbWrapper";
import currentUserInfo from "../selectors/currentUserInfo";
import isLoggingInFromClient from "../selectors/isLoggingInFromClient";
import { refreshTokens, ssoTokenLogin } from "../actions/auth";
import QueryString from "query-string";
import { useEffect } from "react";
import selectUserTokens from "../selectors/selectUserTokens";
import { UnderMaintenance } from "./UnderMaintenance";

export const RouteContext = React.createContext();

// get a dictionary of paths that are in maintenance mode
// from a comma separated list in an env var
const routesInMaintenanceMode = (process.env.REACT_APP_ACCOUNT_ROUTES_IN_MAINTENANCE_MODE || "")
  .split(",")
  .map(path => path.trim())
  .filter(path => path !== "")
  .reduce((paths, path) => ({
    ...paths,
    [path]: true
  }), {})


function isInMaintenanceMode(path) {
  return path in routesInMaintenanceMode
}

// function AccountRoute({exact,path,component,router}) {
function AccountRoute(props) {
  const {exact,path,component,router} = props
  if (!isInMaintenanceMode(path)) {
    return (
      <Route
        exact={exact}
        path={path}
        component={component}
        router={router}
      />
    )
  }
  else {
    console.warn(`${path} is in maintenance mode`)
    return (
      <Route
        exact={exact}
        path={path}
        component={UnderMaintenance}
      />
    )
  }
}

export default function UserAccount(props) {
  const dispatch = useDispatch();
  const currentUrl = new URL(window.location);
  const urlQuery = QueryString.parse(currentUrl.search);
  const [activeTab, setActiveTab] = useState("profile");
  const [activeSubtab, setActiveSubtab] = useState("profile");
  const currentUser = useSelector(currentUserInfo);
  const isFromBBClient = useSelector(isLoggingInFromClient);
  const tokens = useSelector(selectUserTokens);
  const hasAlreadyLoggedIn = useSelector(
    (state) => state.current.fromSSORedirect
  );
  const { match } = props;

  async function onLoad() {
    sessionStorage.setItem("previousRoute", match.url);

    if (urlQuery["token"] && !hasAlreadyLoggedIn) {
      console.log("found token in url", urlQuery["token"]);
      const token = urlQuery["token"];
      //if sso token was not used then log them in for the first time
      try {
        await dispatch(ssoTokenLogin(token, false));
      } catch (e) {
        Log.error(e, "Error caught: /sso login");
      }
    } else {
      if (!currentUser && !isFromBBClient) {
        redirectToLoginPage(props);
      } else {
        Log.info("refreshing tokens");

        dispatch(refreshTokens(tokens.refreshToken));
      }
    }
  }

  useEffect(() => {
    const currentLocation = currentUrl.pathname.split("/");
    const navItem = currentLocation[currentLocation.length - 1];
    setActiveTab(navItem);

    if (
      navItem === "earnings" ||
      navItem === "settings" ||
      navItem === "games"
    ) {
      setActiveSubtab(currentUrl.pathname);
    }

    //eslint-disable-next-line
  }, []);

  useLayoutEffect(() => {
    onLoad(); //eslint-disable-next-line
  }, []);

  function changeTab(tab) {
    setActiveTab(tab);
  }

  function setSubTab(subtab) {
    if (subtab) {
      //return most current subtab state
      setActiveSubtab(() => {
        return subtab;
      });
    }
  }

  const RouteContextValue = {
    setSubTab: setSubTab,
    activeTab: activeTab,
    activeSubtab: activeSubtab,
  };

  return (
    <div
      className={
        isFromBBClient ? styles.profileWrapperNoHeader : styles.profileWrapper
      }
    >
      <RouteContext.Provider value={RouteContextValue}>
        <div className={styles.sideNavWrapper}>
          <ProfileSideNav setTab={changeTab} activeTab={activeTab} />
        </div>
        <div className={styles.accountViewWrapper}>
          <BreadCrumbWrapper>
            <Switch>
              <AccountRoute
                exact
                path={`/account/subscription/billing`}
                component={ManagePaymentPage}
              />
              <AccountRoute
                exact
                path={`/account/subscription/history`}
                component={ProfilePaymentHistoryPage}
              />
              <AccountRoute
                path={`/account/subscription/:product`}
                component={ProfileProductPage}
              />
              <AccountRoute
                path={`/account/ads/:subpage`}
                component={UserAdManagement}
                router={props}
              />
              <AccountRoute
                exact
                path="/account/ads"
                router={props}
                component={UserAdManagement}
              />
              <AccountRoute
                path="/account/profile"
                component={UserProfile}
              />
              <AccountRoute
                exact
                path="/account/subscription"
                component={UserSubscription}
              />
              <AccountRoute path="/account/support" component={UserSupport} />
            </Switch>
          </BreadCrumbWrapper>
        </div>
      </RouteContext.Provider>
    </div>
  );
}
